import axios from "axios"
import { CoreMap } from '@/components/OlMap/Utils/CoreMap'
import {Fill, Stroke, Style,Circle,Text} from 'ol/style.js';
import {WKT} from 'ol/format'
import {get as getProjection} from 'ol/proj';
import {getTopLeft, getWidth} from 'ol/extent';
import WMTSTileGrid from 'ol/tilegrid/WMTS';
const format = new WKT();
const Server_Error_Msg = '服务异常'
export default class GeoserverLayer{
  constructor(props_data){
    const props = props_data || {}
    this.name = props['name'] || ''
    this.url = props['url'] || ''
    this.layer = props['layer'] || ''
    this.count = props['count'] || 200
    this.projection = props['projection'] || ''
    this.geometryField = props['geometryField'] || 'geom'
    this.geometryType = props['geometryType'] || ''
    this.workspace = ''
    this.wmsParameters = {
        service: 'WMS',
        version: '1.1.1',
        request: 'GetFeatureInfo',
        LAYERS:this.layer,
        query_layers: this.layer,
        srs: this.projection,
        FEATURE_COUNT:this.count,
        width: 101,
        height: 101,
        info_format: 'application/json',
        x: 50,
        y: 50,
    }
    this.wfsParameters = {
      service: 'WFS',
      version: '1.0.0',
      request: 'GetFeature',
      typeName:this.layer,
      srsname: this.projection,
      maxFeatures:this.count,
      outputFormat: 'application/json',
    }
    this.id = this.url + '/' + this.layer
    this.fields_=null
    this.getFields()
  }

  getFields(){
    const url = this._getWfsUrl(this.url) 
    const {typeName,service,version,outputFormat} = this.wfsParameters
    const params = {
      service,typeName,version,outputFormat,request:'DescribeFeatureType'
    }
    return new Promise((resolve,reject)=>{
      if (this.fields_) {
        resolve(this.fields_,this.layer)
        return
      }
      axios.get(url,{params}).then(res=>{
        const data=res.data
        if (!data) return
        const featureTypes = data.featureTypes
        this.workspace = data.targetNamespace
        const arr = this.layer.split(':')
        const layerName = arr.length>1?arr[1] :arr[0]
        const featureType =featureTypes? featureTypes.find(it=>it.typeName===layerName):null
        if (featureType) {
          const fields = featureType.properties
          fields.forEach(f=>{
            if(f.type.includes('gml:')){
              this.geometryField = f.name
              this.geometryType = f.localType
            }
          })
          this.fields_ = fields
          resolve(fields,this.layer)
        }else{
          reject("查询服务图层字段信息失败！")
        }
       
      })
    }) 
  }

  getWmsLayer(props_data){
    const props = props_data || {}
    return CoreMap.getWmsLayer({
      url:this.url,
      layer:this.layer,
      ...props
    })
  }

  getWfsLayer(props_data){
    const props = props_data || {}
    if (!props.style) {
      props.style = new Style({
        fill: new Fill({
          color: 'rgba(255, 0, 0, 0.2)'
        }),
        stroke: new Stroke({
          color: 'rgba(255, 0, 0, 0.6)',
        })
      })
    }
    return  CoreMap.getWfsLayer({
      url:this.url,
      layer:this.layer,
      projection:this.projection,
      ...props
    })
  }
  getWmtsLayer(props_data){
    const props = props_data || {}
    const maxZoom = props["maxZoom"] || 18;
    const minZoom = props["minZoom"] || 0;
    const format = props["format"] || 'image/jpeg';

    const projection = this.projection
    const projDef = getProjection(projection);
    const projectionExtent = projDef.getExtent();
    const size = getWidth(projectionExtent) / 256;
    const resolutions = new Array(maxZoom);
    const matrixIds = new Array(maxZoom);
    for (let z = minZoom; z < maxZoom; ++z) {
      resolutions[z] = size / Math.pow(2, z);
      matrixIds[z] = `${projection}_${this.layer}:${z}`;
    }
    const tileGrid = new WMTSTileGrid({
        origin: getTopLeft(projectionExtent),
        resolutions: resolutions,
        matrixIds: matrixIds,
    })
    return  CoreMap.getWMTSLayer({
      url:this.url,
      layer:this.layer,
      projection:this.projection,
      format,
      tileGrid,   
      minZoom,
      maxZoom,
    })
  }
  getMvtLayer(){
    return  CoreMap.getMvtLayer({
      url:this.url,
      layer:this.layer,
      projection:this.projection
    })
  }
  addFeature(feature,properties = null){
    if (!feature) {
      return new Promise((resolve)=>{
        resolve(false)
      })
    }
    const formatFeature = CoreMap.getFormatFeature(feature, this.geometryField,this.geometryType)
    if (properties) {
      formatFeature.setProperties(properties)
    }
    return new Promise((resolve,reject)=>{
      this._alterFeature({inserts:[formatFeature]}).then(res=>{
        if(res.data.includes('ExceptionReport')){
          const msg = this._tryMatch(res.data,/<ows:ExceptionText>(.*)</)
          reject(msg?msg[1]:Server_Error_Msg)
        }else{
          const str = this._tryMatch(res.data,/fid="(\S*)"/)
          const featureId = str ? str[1] : null
          resolve(featureId)
        }
      }).catch(()=>{
        reject(Server_Error_Msg)
      })
    })
  }

  updateFeature(feature,properties = null){
    if (!feature) {
      return new Promise((resolve)=>{
        resolve(false)
      })
    }
    const formatFeature = CoreMap.getFormatFeature(feature, this.geometryField)
    formatFeature.setId(feature.getId()) 
    if (properties) {
      formatFeature.setProperties(properties)
    }
    return new Promise((resolve,reject)=>{
      this._alterFeature({updates:[formatFeature]}).then(res=>{
        if(res.data.includes('ExceptionReport')){
          const msg = this._tryMatch(res.data,/<ows:ExceptionText>(.*)</)
          reject(msg?msg[1]:Server_Error_Msg)
        }else{
          resolve(true)
        }
      }).catch(()=>{
        reject(Server_Error_Msg)
      })
    }) 
  }
  updateFeatures(features,properties = null){
    return new Promise((resolve)=>{
      if (!features){
        resolve(false)
      }
      const formatFeatures = features.map(feature=>{
        const formatFeature = CoreMap.getFormatFeature(feature, this.geometryField)
        formatFeature.setId(feature.getId())
        if (properties) {
          formatFeature.setProperties(properties)
        }
        return formatFeature
      })
      this._alterFeature({updates:formatFeatures}).then(res=>{
        if(res.data.includes('ExceptionReport')){
          const msg = this._tryMatch(res.data,/<ows:ExceptionText>(.*)</)
          reject(msg?msg[1]:Server_Error_Msg)
        }else{
          resolve(true)
        }
      }).catch(()=>{
        reject(Server_Error_Msg)
      })
    })
  }
  deleteFeatures(features){
    const deletes = Array.isArray(features)?features:[features]
    return new Promise((resolve,reject)=>{
      this._alterFeature({deletes}).then(res=>{
        if(res.data.includes('ExceptionReport')){
          const msg = this._tryMatch(res.data,/<ows:ExceptionText>(.*)</)
          reject(msg?msg[1]:Server_Error_Msg)
        }else{
          resolve(true)
        }
      }).catch(()=>{
        reject(Server_Error_Msg)
      })
    })
  }

  pointQuery(point,resolution=0,sql,tolerance=20){
    return new Promise((resolve,reject)=>{
      const d = resolution * tolerance || 0
      const c = Array.isArray(point)?point: point?.getCoordinates()
      const url = this._getWmsUrl(this.url) 
      if (!c || !url) {
        reject()
      }
      const bbox = [c[0]-d,c[1]-d,c[0]+d,c[1]+d,this.projection]
      const params ={...this.wmsParameters,bbox: bbox.join(',')}
      sql && (params.cql_filter= sql)
      axios.get(url,{params}).then(res=>{
        if (res.data) {
          resolve(res.data,this.layer)
        }else{
          reject()
        }
      })
    })
  }
  boxQuery(extent){
    const url = this._getWfsUrl(this.url) 
    const params ={...this.wfsParameters,bbox: extent.join(',')}
    return new Promise((resolve)=>{
      axios.get(url,{params}).then(res=>{
        if (res.data) {
          resolve(res.data)
        }
      })
    })
    
  }
  polygonQuery(geometry){
    return new Promise((resolve)=>{
      this._intersects(geometry).then(res=>{
        resolve(res.data,this.layer)
      })
    })
  }
  attributeQuery(sql,startIndex=0){
    const params ={...this.wfsParameters}
    if (startIndex>0) {
      params.startIndex = startIndex
    }
    if(sql){
      params.cql_filter=sql
    }
    const url = this._getWfsUrl(this.url) 
    return new Promise((resolve)=>{
      axios.get(url,{params}).then(res=>{
        if (res.data) {
          resolve(res.data,this.layer)
        }
      })
    }) 
  }

  getFeatureById(fid){
    const url = this._getWfsUrl(this.url)
    const layer = this.getLayerName()
    const params ={...this.wfsParameters,FEATUREID:`${layer}.${fid}`}
    return new Promise((resolve)=>{
      axios.get(url,{params}).then(res=>{
        if (res.data) {
          resolve(res.data,this.layer)
        }
      })
    }) 
  }

  getInfos(){
    const params ={
      service: 'WMS',
      version: '1.1.1',
      request: 'GetCapabilities',
      dataType:'xml'
    }
    const url = this._getWmsUrl(this.url)
    return axios.get(url,{
      params,
      headers:{
        "Content-type": "application/xml"
      }
    })
  }
  getLayerInfos(){
    const splits = this.layer.split(':')
    const layerName = splits?.length<2?splits[0]:splits[1]
    return new Promise((resolve)=>{
      this.getInfos().then(res=>{
        const infos = res.data
        const parser = new DOMParser();
        const doc = parser.parseFromString(infos, "application/xml");
        const layers = doc.querySelectorAll("Layer Layer[queryable='1']")
        layers.forEach(lyr=>{
          const name = lyr.querySelector('Name').innerHTML
          const hasFindLayer = name.includes(":")?name === this.layer:name === layerName
          if (hasFindLayer) {
            resolve(lyr)
          }
        })
      })
    })
  }

  getLayerExtent(){
    return new Promise((resolve)=>{
      this.getLayerInfos().then(lyr=>{
        const dom = lyr.querySelector('LatLonBoundingBox')
        resolve(dom?this._tryGetExtentFromDom(dom):null)
      })
    })
    
  }

  getLayerName(){
    const layerInfo = this.layer.split(':')
    return layerInfo.length>1?layerInfo[1]:layerInfo[0]
  }

  _tryGetExtentFromDom(dom){
    const minx = this._tryGetNumber(dom.getAttribute('minx')) || -180
    const miny = this._tryGetNumber(dom.getAttribute('miny')) || -90
    const maxx = this._tryGetNumber(dom.getAttribute('maxx')) || 180
    const maxy = this._tryGetNumber(dom.getAttribute('maxy')) || 90
    return [minx,miny,maxx,maxy]
  }

  _getWfsUrl(mapUrl){
    const isGwcMapServer = mapUrl.includes('gwc/service/')
    const workspaceName = this.layer.split(':')[0]
    if(isGwcMapServer){
        return mapUrl.replace('gwc/service/wms',`${workspaceName}/wfs`)
    }else{
        return mapUrl.replace('/wms','/wfs')
    }
  }
  _getWmsUrl(mapUrl){
    const isGwcMapServer = mapUrl.includes('gwc/service/')
    const workspaceName = this.layer.split(':')[0]
    if(isGwcMapServer){
      return mapUrl.replace('gwc/service/wms',`${workspaceName}/wms`)
  }else{
      return mapUrl.replace('/wfs','/wms')
  }
  }
  _alterFeature(props_data){
    const props = Object.assign( this._getDefaultProps(),props_data||{})
    return CoreMap.writeTransaction(props)
  }


  _intersects(geometry){
    const props = this._getDefaultProps()
    props.geometry = geometry
    props.geometryName = this.geometryField
    return CoreMap.intersects(props)
  }

  _getDefaultProps(){
    const props = {}
    props.url = this.url
    const layerInfo = this.layer.split(':')
    if (layerInfo.length > 1) {
      props.workspace =this.workspace? this.workspace : layerInfo[0]
      props.layer = layerInfo[1]
    }else{
      props.layer = layerInfo[0]
    }
    props.projection = this.projection
    return props
  }

  _tryGetNumber(str){
    try {
      return Number(str)
    } catch (error) {
      return null
    }
  }

  _tryMatch(str,reg){
    try {
      return str.match(reg)
    } catch (error) {
      return null
    }
  }
}


